import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import './style.scss'

/**
 * Right lateral section displayable in all pages
 *
 * @see https://mui.com/components/grid/
 * @see https://mui.com/api/grid/
 * @param {object} props, Ex: <PageRight isVisible={false}>bla bla...</PageRight>
 * @returns {Grid}
 */
export const PageRight = ({ isVisible, className, children }) => (
  <Grid
    item={true}
    xs={true}
    className={`commonPage_container_lateral right ${className}`}
    style={{ display: isVisible ? 'block' : 'none' }}
  >
    {children}
  </Grid>
)

PageRight.displayName = 'PageRight'

PageRight.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isVisible: PropTypes.bool
}

PageRight.defaultProps = {
  isVisible: true,
  className: ''
}
